import React, { PropTypes } from 'react';
import Icon from 'components/Icon';
import Checkable from 'components/Checkable';
// import outClick from 'decorators/outClick';
import cx from './LanguageSelector.scss';

const options = __('languages');

import withStyles from 'decorators/withStyles';

@withStyles(cx)
// @outClick(component => component.setState({ expanded: false }))
export default class LanguageSelector extends React.Component {
	static propTypes = {
		value: PropTypes.arrayOf(PropTypes.string).isRequired,
		onChange: PropTypes.func.isRequired,
		title: PropTypes.string,
	};

	state = {
		expanded: false,
	};

	handleChange(key, checked) {
		const { value, onChange } = this.props;

		if(checked) {
			onChange([...value, key]);
		} else {
			onChange(value.filter(v => v !== key));
		}
	}

	render() {
		const { value, title = '' } = this.props;
		const { expanded } = this.state;

		return (
			<div className={cx('main')}>
				<a className={cx('button', { expanded })} onClick={() => this.setState({ expanded: !expanded })}>
					<Icon type="settings" />
				</a>

				{expanded &&
					<div className={cx('list')}>
						<h5 className={cx('title')}>
							{title}
						</h5>
						{Object.keys(options).map(key =>
							<div key={key} className={cx('item')}>
								<Checkable
									type="checkbox"
									checked={value.indexOf(key) > -1}
									onChange={checked => this.handleChange(key, checked)}
								>
									{options[key]}
								</Checkable>
							</div>
						)}
					</div>
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/react/components/LanguageSelector/LanguageSelector.js